import { z } from 'zod';

// Les `message` sont des clés de traduction (namespace `auth.errors`).
export const signupSchema = z.object({
  firstName: z.string().trim().min(1, { message: 'firstNameRequired' }).max(80),
  lastName: z.string().trim().min(1, { message: 'lastNameRequired' }).max(80),
  email: z.string().email({ message: 'emailInvalid' }),
  password: z.string().min(8, { message: 'passwordTooShort' }),
});

export type SignupInput = z.infer<typeof signupSchema>;
